import CardHead from './CardHead';

export default CardHead;
